import React, { createContext, useEffect, useRef } from 'react';

export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const socketRef = useRef(null);

  useEffect(() => {
    // Use localhost for development, production URL for deployed app
    const wsUrl = process.env.REACT_APP_WS_URL || 'ws://localhost:10000';
    socketRef.current = new WebSocket(wsUrl);

    socketRef.current.onopen = () => {
      console.log('🟢 WebSocket connected to', wsUrl);
    };

    socketRef.current.onclose = () => {
      console.log('🔴 WebSocket disconnected');
    };

    socketRef.current.onerror = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    return () => {
      socketRef.current.close();
    };
  }, []);

  return (
    <WebSocketContext.Provider value={socketRef.current}>
      {children}
    </WebSocketContext.Provider>
  );
};
